import { render, staticRenderFns } from "./BRegistration.vue?vue&type=template&id=b1e8a296&scoped=true&"
import script from "./BRegistration.vue?vue&type=script&lang=js&"
export * from "./BRegistration.vue?vue&type=script&lang=js&"
import style0 from "./BRegistration.vue?vue&type=style&index=0&id=b1e8a296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e8a296",
  null
  
)

export default component.exports